// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'


import FzgHome from './components/home/FzgHome.vue'
import FzgAbout from './components/about/FzgAbout.vue'
import FzgChuangFu from './components/service/FzgChuangFu.vue'
import FzgChuangTou from './components/investment/FzgChuangTou.vue'
import FzgFa from './components/fa/FzgFa.vue'
import FzgNews from './components/news/FzgNews.vue'
import FzgJoin from './components/join/FzgJoin.vue'
import FzgJoinDetail from './components/join/FzgJoinDetail.vue'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueResource);

const routes = [
  { path: '/', component: FzgHome},
  { path: '/about', component: FzgAbout},
  { path: '/service', component: FzgChuangFu},
  { path: '/investment', component: FzgChuangTou},
  { path: '/fa', component: FzgFa},
  { path: '/news', component: FzgNews},
  { path: '/join', component: FzgJoin},
  { path: '/join/jd', component: FzgJoinDetail},

]

const router = new VueRouter({
  mode: 'history',
  routes // short for `routes: routes`
})

const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js